import { GameTableConfig } from './GameTableConfig';
import { IGameRules } from '../games/common/IGameRules';
import { SeatPosition } from '../state/ArenaTypes';

/**
 * Returns player count for the table (standard 4-seat).
 */
export function getPlayerCount(_config?: GameTableConfig | null, rules?: IGameRules | null): number {
  if (rules?.getPlayerCount) return rules.getPlayerCount();
  return 4;
}

/**
 * Returns total tricks played per hand on the felt.
 */
export function getTricksPerHand(config?: GameTableConfig | null, rules?: IGameRules | null): number {
  if (config?.features?.totalTricksPerHand !== undefined) return config.features.totalTricksPerHand;
  if (rules?.deckSpec?.cardsPerPlayer !== undefined) return rules.deckSpec.cardsPerPlayer;
  return 12;
}

/**
 * Returns kitty size (0 for games without kitty like Spades).
 */
export function getKittySize(config?: GameTableConfig | null, rules?: IGameRules | null): number {
  if (config?.deck?.kittyCards !== undefined) return config.deck.kittyCards;
  if (rules?.deckSpec?.kittyCardsCount !== undefined) return rules.deckSpec.kittyCardsCount;
  return 6;
}

/**
 * Returns cards dealt to each player.
 */
export function getCardsPerPlayer(config?: GameTableConfig | null, rules?: IGameRules | null): number {
  if (config?.deck?.cardsPerPlayer !== undefined) return config.deck.cardsPerPlayer;
  if (rules?.deckSpec?.cardsPerPlayer !== undefined) return rules.deckSpec.cardsPerPlayer;
  return 12;
}

/**
 * Standard partnership team assignment:
 * Seats 0 (South) & 2 (North) -> Team 1
 * Seats 1 (West) & 3 (East) -> Team 2
 */
export function getTeamForSeat(seat: SeatPosition | number, rules?: IGameRules | null): 1 | 2 {
  if (rules?.getTeamForSeat) return rules.getTeamForSeat(seat as SeatPosition);
  return (seat === 0 || seat === 2) ? 1 : 2;
}

/**
 * Across-the-table partner seat index: (seat + 2) % 4
 */
export function getPartnerSeat(seat: SeatPosition | number, rules?: IGameRules | null): SeatPosition {
  if (rules?.getPartnerSeat) return rules.getPartnerSeat(seat as SeatPosition);
  return ((Number(seat) + 2) % 4) as SeatPosition;
}

/**
 * Next seat clockwise: (seat + 1) % 4
 */
export function getNextSeat(seat: SeatPosition | number): SeatPosition {
  return ((Number(seat) + 1) % 4) as SeatPosition;
}

/**
 * Returns trick terminology ('book'/'books' or 'trick'/'tricks') for display.
 */
export function getTrickNoun(plural: boolean = false, config?: GameTableConfig | null, rules?: IGameRules | null): string {
  if (config?.ui?.trickNounPlural && plural) return config.ui.trickNounPlural;
  if (config?.ui?.trickNoun && !plural) return config.ui.trickNoun;
  if (rules?.getTrickNoun) return rules.getTrickNoun(plural);
  return plural ? 'tricks' : 'trick';
}
